export enum VoucherQuantity {
    Min = 1,
    Max = 25,
}
